import { useState } from 'react';

import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import toastMsg from '../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../constants/service/toastMsg/accountUserToastMsg';
import {
  ACCOUNT_USER_DETAIL_POINT_HISTORY_LIST_FILTER_OPTION_MODEL,
  POINT_GENERATE_VALID_RESULT_MODEL,
} from './models';
import appToastMsg from '../../../../../constants/service/toastMsg/appToastMsg';
import {
  useAccountUserDetailPointListQuery,
  useAccountUserPointDetailQuery,
  useCheckValidGeneratePointMutate,
} from './query';
import { getTablePages } from '../../../../../lib/utils/tableUtils';

export const useAccountUserPointDetail = ({ userId, isActive }) => {
  const { data } = useAccountUserPointDetailQuery({
    userId,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_POINT_DETAIL_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => ({
        userPersonalInfo: result.data.userInfo,
        pointCauseSelectList: result.data.pointCauseSelectList,
      }),
    },
  });

  return data;
};

export const useAccountUserDetailPointList = ({ userId, isActive }) => {
  const [pagination, setPagination] = useState(LIST_PAGINATION_MODEL);
  const [filterOption, setFilterOption] = useState(ACCOUNT_USER_DETAIL_POINT_HISTORY_LIST_FILTER_OPTION_MODEL);

  const { data } = useAccountUserDetailPointListQuery({
    userId,
    pagination,
    filterOption,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_POINT_LIST_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => ({
        list: result.data.pointHistoryList.list,
        totalCnt: result.data.pointHistoryList.totalCnt,
      }),
    },
  });

  return {
    pointHistoryList: data,
    pagination: { ...pagination, pages: getTablePages(data.totalCnt, pagination.pageSize) },
    filterOption,
    setPagination,
    setFilterOption,
  };
};

export const useCheckValidGeneratePoint = () => {
  const {
    mutate,
    data: result,
    reset,
  } = useCheckValidGeneratePointMutate({
    options: {
      onSuccess: () => toastMsg.success(appToastMsg.CHECK_VALID_GENERATE_POINT_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
    },
  });

  return {
    checkValidGeneratePoint: mutate,
    resetValidResult: reset,
    validResult: result?.data || POINT_GENERATE_VALID_RESULT_MODEL,
  };
};
